import React from "react";
import { RelatedItem } from "../../../types";
import * as styles from "./ArticleSidebar.module.css";
import { KontentImageElement } from "../KontentImageElement/KontentImageElement";
import { Link } from "../Link/Link";

interface Props {
  relatedItems?: RelatedItem[];
}

const ArticleSidebar = ({ relatedItems }: Props) => {
  const renderSidebarItem = (item: RelatedItem, idx: number) => {
    if (!item.url || !item.title) {
      return null;
    }

    let image = null;
    if (item.image?.largeImage && item.image?.largeImage?.item?.url) {
      image = (
        <div className={styles.sidebarImage}>
          <KontentImageElement
            image={item.image.largeImage.item}
            alt={item.image.largeImage.alt}
            layout="constrained"
            height={210}
            width={210}
          />
        </div>
      );
    }

    return (
      <li className={styles.sidebarListItem} key={item.url + idx}>
        <Link to={item.url} target="_self">
          {image}
          <div className={styles.sidebarItemContent}>
            <div>{item.title}</div>
            {item.category && (
              <div className={styles.sidebarItemCategory}>{item.category}</div>
            )}
            {item.date && (
              <div className={styles.sidebarItemDate}>{item.date}</div>
            )}
          </div>
        </Link>
      </li>
    );
  };

  return (
    <>
      <div className={styles.more}>More</div>
      <hr />
      <ul className={styles.sidebarItemList}>
        {relatedItems?.map((item, idx) => renderSidebarItem(item, idx))}
      </ul>
    </>
  );
};

export default ArticleSidebar;
